import React, { useEffect } from 'react';

import { connect } from 'containers/store'
import { SharedActionCreators, sharedActionCreators } from 'containers/shared';

import { GettyActionCreators, actionCreators } from 'domains/org/getty/actions';
import { GettyStore } from 'domains/org/getty/store';

import { Confirm } from 'components/ui/modal';
import { StatusGuard } from 'components/ui/status-guard';

import { categorySchema } from '../../../schemas/category'

import { pick } from 'helpers/core'
import { Status } from 'helpers/status';

import { TourCategory } from 'generated/mos/org/getty/audio'
import { DeleteTourCategoryRequest }  from 'generated/mos/org/getty/audiomanagement';


type ActionProps =
  Pick<GettyActionCreators, 'gettyDeleteTourCategoryRequest'> &
  Pick<SharedActionCreators, 'toastNotification'>;

type ConnectedProps = Pick<GettyStore['getty'], 'categoryDelete'>;

type DirectProps = {
  readonly category: TourCategory.Entity;
  readonly onCancel: () => void;
}

type Props = ActionProps & ConnectedProps & DirectProps;

const CategoryDeleteView = (props: Props) => {
  const {
    gettyDeleteTourCategoryRequest,
    toastNotification,
    categoryDelete,
    onCancel,
    category,
  } = props

  const message = <>
    <p>Are you sure you want to permanently delete</p>
    <p>"{categorySchema.name.read(category.name)}"?</p>
  </>

  const onConfirmDelete = () => {
    const id = category.ref ? category.ref.id : ''
    gettyDeleteTourCategoryRequest({
      ...DeleteTourCategoryRequest.defaults,
      tourCategoryRef: {
        typename: 'mos.org.getty.audio.TourCategory' as const,
        id,
      },
    })
    onCancel()
  }

  useEffect(() => {
    categoryDelete.status === Status.Failed &&
      toastNotification({
        type: 'error',
        text: 'Could not delete category',
      });
  }, [categoryDelete.status, toastNotification])

  return (
    <StatusGuard status={categoryDelete}>
      <Confirm
        title="Delete Category?"
        onClose={onCancel}
        message={message}
        confirmLabel="Delete"
        onConfirm={onConfirmDelete}
        danger
      />
    </StatusGuard>
  );
};

export const CategoryDelete = connect<ConnectedProps, ActionProps, DirectProps, GettyStore, GettyActionCreators>(
  (store) => pick(store.getty, 'categoryDelete'),
  {
    ...pick(actionCreators, 'gettyDeleteTourCategoryRequest'),
    ...pick(sharedActionCreators, 'toastNotification')
  }
)(CategoryDeleteView)
